
























































import {Component, Prop, Vue} from 'vue-property-decorator'
import {$, ID, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import Alerta from '@/model/resource/Alerta'

const metaInfo = () => ({
  title: $.t('view.persist.alertPersist.title'),
})

@Component({
  metaInfo,
})
export default class AlertPersistView extends Vue {
  @Prop({type: [String, Number]}) id?: ID

  AppConfig = AppConfig

  listToPersist: Alerta[] = []

  created() {
    this.$set(this.listToPersist, 0, new Alerta())
  }

  async mounted() {
    if (this.id) await this.listToPersist[0].getAlerta(this.id)
    $.await.done('getAlerta')
  }

  addItem() {
    this.listToPersist.push(new Alerta())
  }

  removeItem(item: Alerta) {
    const index = this.listToPersist.indexOf(item)
    if (index > -1) {
      this.listToPersist.splice(index, 1)
      this.$forceUpdate()
    }
  }

  async persist() {
    await Alerta.persistLoteAlerta(this.listToPersist)
    successAndPush('system.success.persist', '/manage/alert/list')
  }

}
